<template>
    <v-container class="main-container">
        <v-row>
            <v-card
                class="mx-auto"
                width="600"
                
                >
                <v-card-text>
                    <v-form
                    >
                        <v-subheader>Dina uppgifter</v-subheader>

                        <v-row>
                            <v-col
                            cols="12"
                            md="12"
                            >

                                <v-text-field
                                v-model="client.public_id"
                                label="Kundnummer"
                                readonly
                                color="black"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                            cols="12"
                            md="12"
                            >
                                <v-text-field
                                v-model="client.firstname"
                                label="Förnamn"
                                readonly
                                color="black"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                            cols="12"
                            md="12"
                            >
                                <v-text-field
                                v-model="client.lastname"
                                label="Efternamn"
                                readonly
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                            cols="12"
                            md="12"
                            >
                                <v-text-field
                                v-model="client.email"
                                label="E-post"
                                readonly
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                            cols="12"
                            md="12"
                            >
                                <v-text-field
                                v-model="client.phone"
                                label="Mobiltelefon"
                                readonly
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                            cols="12"
                            md="12"
                            >
                                <v-text-field
                                v-model="client.address"
                                label="Gatuadress"
                                readonly
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                            cols="12"
                            md="4"
                            >
                                <v-text-field
                                v-model="client.zipcode"
                                label="Postkod"
                                readonly
                                ></v-text-field>
                            </v-col>
                            <v-col
                            cols="12"
                            md="4"
                            >
                                <v-text-field
                                v-model="client.postaddress"
                                label="Postort"
                                readonly
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-row>
    </v-container>
</template>


<script>
export default {
    props: ['client'],
    created(){
        
    },
    computed: {
        static_urls() {
            return this.$store.state.static_urls;
        },
        booking() {
            return this.$store.getters.publicBooking
        },
        loading() {
            return this.$store.getters.bookingLoading
        },
    },
    data() {
        return {
            
        };      
    },
    methods: {
        purchaseUpsell(upsell_id) {
        
        }
    }
}
</script>

<style scoped>
.v-text-field {
    margin-top: 0px !important;
    padding-top: 0px !important;
}
.main-container {
    
}
</style>